/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { type AssistantStep, Steps } from '@/types';

const ASSISTANT_STEPS: Partial<Record<Steps, AssistantStep>> = {
  [Steps.Selection]: {
    title: 'Sélection',
    dataTestId: 'assistant-step-selection',
  },
  [Steps.Verification]: {
    title: 'Vérification des données',
    dataTestId: 'assistant-step-verification',
  },
};

export default ASSISTANT_STEPS;
